<template>
  <div style="display: flex; flex-direction: column;align-content: space-around; align-items: flex-start">
    <!-- <a href="javascript:;" @click="update">updata</a> -->
    <FBAExclDown :record="record" :disabled="record.fbaUploadCarton == 0" />
    <FBAExclUpload :record="record" @success="successCall" :shipmentId="record.fbaShipmentId"
      :customerShopId="record.customerShopId" :disabled="record.fbaUploadCarton == 0" />
  </div>
</template>

<script>
import FBAExclDown from "@/views/outOfStock/internationalShipment/components/FBAFun/FBAExclDown";
import FBAExclUpload from "@/views/outOfStock/internationalShipment/components/FBAFun/FBAExclUpload";
export default {
  name: "FBAFun",
  components: {
    FBAExclUpload,
    FBAExclDown
  },
  props: {
    record: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    successCall: function (payload) {
      this.$emit('success')
    },
    update: function () {
      // todo
      this.$emit('success')
    }
  }
}
</script>

<style scoped></style>